import { render } from "./transistate.vue?vue&type=template&id=12405af6&scoped=true"
import script from "./transistate.vue?vue&type=script&lang=js"
export * from "./transistate.vue?vue&type=script&lang=js"

import "./transistate.vue?vue&type=style&index=0&id=12405af6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12405af6"]])

export default __exports__